export default __webpack_public_path__ + "297839f1475e53db39621fe5f5f99c01.svg";